/** Keep in sync with packages/app/brandPalette.cjs */
export const LYW_BRAND = {
  vibrantGreen: '#00b366',
  silverTree: '#5fb393',
  blumine: '#1a5172',
  blumineDark: '#143d57',
  edgewater: '#cbe3e2',
  monteCarlo: '#85c8d4',
  abbey: '#555656',
  stack: '#848a85',
  mint: '#afe0bd',
  slate: '#486e81',
  actionBlue: '#2563eb',
  actionBlueDark: '#1d4ed8',
  destructiveAction: '#D4616B',
  destructiveActionDark: '#BE5059',
  confirmAction: '#16a34a',
  confirmActionDark: '#15803d',
  confirmActionTint: '#f0fdf4',
} as const;

/** Shared filled primary CTA (Get Started, Create Unit, dialog confirms). */
export const actionBlueButtonClass = 'bg-action-blue hover:bg-action-blue-dark text-white';

/** Dialog / form primary confirm (filled) */
export const actionBlueDialogButtonClass =
  'px-6 py-2 bg-action-blue hover:bg-action-blue-dark text-white rounded-lg transition-colors';

/** Outline primary (Share, secondary CTAs on unit cards) */
export const actionBlueOutlineButtonClass =
  'text-action-blue border-action-blue/30 hover:bg-action-blue/10';

/** Info panel in primary dialogs */
export const actionBluePanelClass =
  'bg-action-blue/10 rounded-lg border border-action-blue/30';

export const actionBlueTextClass = 'text-action-blue';

export const actionBlueFocusRingClass = 'focus:ring-action-blue focus:border-action-blue';

/** Filled destructive CTA */
export const destructiveActionButtonClass =
  'bg-destructive-action hover:bg-destructive-action-dark text-white';

/** Dialog / form confirm destructive (filled) */
export const destructiveActionDialogButtonClass =
  'px-6 py-2 bg-destructive-action hover:bg-destructive-action-dark text-white rounded-lg transition-colors';

/** Outline destructive (Abandon Unit, etc.) */
export const destructiveActionOutlineButtonClass =
  'text-destructive-action border-destructive-action/30 hover:bg-destructive-action/10';

/** Warning / caution panel in destructive dialogs */
export const destructiveActionPanelClass =
  'bg-destructive-action/10 rounded-lg border border-destructive-action/30';

export const destructiveActionTextClass = 'text-destructive-action';

export const destructiveActionIconHoverClass =
  'text-gray-400 hover:text-destructive-action';

/** Filled confirm CTA (completion dialogs, etc.) */
export const confirmActionButtonClass =
  'bg-confirm-action hover:bg-confirm-action-dark text-white';

/** Outline confirm (Review Units Approve, Finish activity, etc.) */
export const confirmActionOutlineButtonClass =
  'text-confirm-action border-confirm-action/30 hover:bg-confirm-action/10';

export const confirmActionTextClass = 'text-confirm-action';

export const confirmActionPanelClass =
  'bg-confirm-action/10 rounded-lg border border-confirm-action/30';

export const confirmActionBadgeClass =
  'bg-confirm-action/15 text-confirm-action-dark';
